const Separator = ({margin}) => (
  <div
    style={{ height: "0.05rem", backgroundColor: "#e2e2e2", margin: margin }}
  />
);

export default Separator;
